import React from 'react';
import { App } from '@gin-betting/core';
import cn from 'classnames';
import { noop } from 'lodash';

import { Icon } from 'components';
import { Target, tracker } from 'services/tracking-manager';
import { OddIcon } from '../Odd';
import UpdatesSettings from './UpdatesSettings';
import useBetslipHeader from './useBetslipHeader';

import trash from 'assets/svg/del-basket.svg';
import './betslipHeader.scss';

interface Props {
    betslipBetId: string;
    isOpened: boolean;
    betslipBetsSize: number;
}

const BetslipHeader: React.FC<Props> = ({
    betslipBetId,
    isOpened,
    betslipBetsSize,
}) => {
    const props = useBetslipHeader({
        betslipBetId,
        betslipBetsSize,
        isOpened,
    });

    if (!props) return null;

    const {
        status,
        betsSize,
        betCountTitle,
        deleteTitle,
        successTitle,
        changeOddUpdateStatus,
        oddUpdateStatus,
        deleteBetslipOdds,
        choseBetslipBetId,
    } = props;

    const isEmpty = betsSize === 0;
    const isInitial = status === App.BetslipStatus.INITIAL;
    const isProcessing = status === App.BetslipStatus.PROCESSING;
    const isError = status === App.BetslipStatus.ERROR;
    const isSuccess = status === App.BetslipStatus.SUCCESS;
    const isSuspended = isSuccess || isProcessing;

    return (
        <div
            className="__app-BetslipHeader-container"
            styleName={cn('container', {
                'is-active': isInitial,
                'is-processing': isProcessing,
                'is-completed': isSuccess,
                'has-error': isError,
                'is-closed': !isOpened,
            })}
            onClick={choseBetslipBetId}
        >
            <div
                styleName="label"
                {...tracker().markTarget(Target.OddsUpdates)}
            >
                {(isProcessing || isSuccess) && (
                    <OddIcon status={status} clickHandler={noop} />
                )}
                <span styleName="label-text">
                    {isSuccess ? successTitle : `${betsSize} ${betCountTitle}`}
                </span>
            </div>

            {isOpened && (
                <div
                    styleName="button-wrapper"
                    className="__app-BetslipHeader-BetslipHeader-button-wrapper"
                >
                    {isInitial && (
                        <UpdatesSettings
                            changeOddUpdateStatus={changeOddUpdateStatus}
                            oddUpdateStatus={oddUpdateStatus}
                        />
                    )}

                    {!isSuspended && (
                        <Icon
                            styleName={cn('icon', {
                                disabled: isEmpty,
                            })}
                            glyph={trash}
                            onClick={deleteBetslipOdds}
                            title={deleteTitle}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default BetslipHeader;
